import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

export const VideoCameraDisableIcon = (props: SvgIconProps) => (
  <SvgIcon width="28" height="28" viewBox="0 0 28 28" {...props}>
    <path
      opacity="0.2"
      d="M2.625 6.66699H16.625C17.5533 6.66699 18.4435 7.03574 19.0999 7.69212C19.7562 8.3485 20.125 9.23873 20.125 10.167V20.667C20.125 20.8991 20.0328 21.1216 19.8687 21.2857C19.7046 21.4498 19.4821 21.542 19.25 21.542H5.25C4.32174 21.542 3.4315 21.1732 2.77513 20.5169C2.11875 19.8605 1.75 18.9702 1.75 18.042V7.54199C1.75 7.30993 1.84219 7.08737 2.00628 6.92327C2.17038 6.75918 2.39294 6.66699 2.625 6.66699Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.96319 5H16.6217C17.8713 5 19.0697 5.48698 19.9533 6.35382C20.8369 7.22065 21.3333 8.39633 21.3333 9.62222V20.4074C21.3333 20.9182 21.1265 21.4081 20.7583 21.7692C20.3902 22.1304 19.8908 22.3333 19.3701 22.3333H4.71166C3.46205 22.3333 2.26362 21.8463 1.38001 20.9795C0.496405 20.1127 0 18.937 0 17.7111V6.92593C0 6.41514 0.206836 5.92527 0.575005 5.56409C0.943174 5.20291 1.44252 5 1.96319 5ZM2.09407 7.05432H16.6217C17.3159 7.05432 17.9817 7.32487 18.4726 7.80644C18.9635 8.28802 19.2393 8.94117 19.2393 9.62222V20.279H4.71166C4.01743 20.279 3.35164 20.0085 2.86074 19.5269C2.36985 19.0453 2.09407 18.3922 2.09407 17.7111V7.05432Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.5096 8.12969C27.8132 8.30145 28 8.61779 28 8.96V19.04C28 19.3822 27.8132 19.6985 27.5096 19.8703C27.206 20.0421 26.8316 20.0433 26.5269 19.8735L20.4963 16.5135C20.0241 16.2505 19.8601 15.664 20.1299 15.2037C20.3997 14.7434 21.0011 14.5834 21.4733 14.8465L26.0308 17.3857V10.6143L21.4733 13.1535C21.0011 13.4166 20.3997 13.2566 20.1299 12.7963C19.8601 12.336 20.0241 11.7495 20.4963 11.4865L26.5269 8.12649C26.8316 7.9567 27.206 7.95792 27.5096 8.12969Z"
      fill="white"
    />
    <path
      d="M7 17L14 10M14 17L7 10"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </SvgIcon>
);
